<div class="card">
    <div class="border-bottom title-part-padding">
        <h4 class="card-title mb-0">Create a new Pack</h4>
    </div>
    <div class="card-body">
        <div class="pack-form-container">
            <form id="pack-form"
                  class="form-horizontal">

                <div class="mb-3">
                    <label class="form-label">Name<span class="help"> e.g. "Onboarding Pack"</span>
                    </label>
                    <input type="text"
                           class="form-control"
                           value=""
                           name="name"
                           placeholder="Please specify the name" required>
                    <div class="invalid-feedback">Required</div>
                </div>

                <div class="mb-3">
                    <label class="form-label">Description</label>
                    <textarea class="form-control"
                              name="description"
                              rows="3"></textarea>
                </div>

                <div class="mb-3">
                    <label class="form-label mb-1">Templates</label>
                    <p class="text-muted small mb-3">Drag templates from the available list into the pack. Reorder by dragging within the pack list.</p>

                    <div class="template-dnd-container">
                        <div class="template-dnd-panel">
                            <div class="template-dnd-panel-header">
                                <h6 class="mb-0"><i class="ti ti-list-search me-1"></i> Available Templates</h6>
                                <span class="badge bg-primary-subtle text-primary" id="available-count">0</span>
                            </div>
                            <div class="template-dnd-search">
                                <input type="text" class="form-control form-control-sm" id="template-search" placeholder="Search templates...">
                            </div>
                            <div class="template-dnd-list" id="available-templates" data-list="available">
                                <% if ( availableTemplates.length === 0 ) { %>
                                    <div class="template-dnd-empty">
                                        <i class="ti ti-file-off fs-4 text-muted"></i>
                                        <span class="text-muted small">No templates available</span>
                                    </div>
                                <% } %>
                                <% availableTemplates.forEach( ( t ) => { %>
                                    <div class="template-dnd-item" draggable="true" data-template-id="<%= t.id %>">
                                        <div class="template-dnd-item-grip">
                                            <i class="ti ti-grip-vertical"></i>
                                        </div>
                                        <div class="template-dnd-item-content">
                                            <span class="template-dnd-item-name"><%= t.name %></span>
                                            <% if ( t.status === 'ACTIVE' ) { %>
                                                <span class="badge bg-success-subtle text-success badge-sm">Active</span>
                                            <% } else { %>
                                                <span class="badge bg-warning-subtle text-warning badge-sm">Inactive</span>
                                            <% } %>
                                        </div>
                                        <button type="button" class="btn btn-sm btn-outline-primary template-dnd-add" title="Add to pack">
                                            <i class="ti ti-chevron-right"></i>
                                        </button>
                                    </div>
                                <% }); %>
                            </div>
                        </div>

                        <div class="template-dnd-divider">
                            <i class="ti ti-arrows-left-right text-muted"></i>
                        </div>

                        <div class="template-dnd-panel">
                            <div class="template-dnd-panel-header">
                                <h6 class="mb-0"><i class="ti ti-package me-1"></i> Pack Templates</h6>
                                <span class="badge bg-success-subtle text-success" id="selected-count">0</span>
                            </div>
                            <div class="template-dnd-list template-dnd-list-selected" id="selected-templates" data-list="selected">
                                <div class="template-dnd-empty template-dnd-drop-hint" id="drop-hint">
                                    <i class="ti ti-drag-drop fs-4 text-muted"></i>
                                    <span class="text-muted small">Drag templates here or click the arrow button</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-body border-top mt-6">
                    <button type="button"
                            data-id="submit-form"
                            class="btn btn-primary">
                        Save
                    </button>
                    <a href="/pack/list" class="btn bg-danger-subtle text-danger ms-6">
                        Cancel
                    </a>
                </div>

            </form>
        </div>
    </div>
</div>
